<template>  
  <v-ons-page id="subscriptions" @hide="onHide" @show="onShow">   
    <v-ons-progress-bar indeterminate class="app-bar-progress" v-bind:style="{top: '0.1rem'}" v-show="loading"></v-ons-progress-bar> 
    <ons-toolbar class="toolbar-fake"></ons-toolbar>
    <top-pull-hook :action="reload" />
    <main role="main">      
      <h1 class="page-title">{{ $t("subscriptions.title") }}</h1>
      <!-- <form action="" class="search-box">
        <ons-search-input placeholder="Search" modifier="full"></ons-search-input>
        <v-ons-progress-bar indeterminate style="position: absolute; width: 100%; left: 0; bottom: -2px;" v-show="loading"></v-ons-progress-bar>
      </form> -->
      <div class="tabs tabbar tabbar--top" data-control="#tabs-content-tag" v-if="!isOffline">
        <label class="tabbar__item" data-index="1">
        <input type="radio" name="tab-tag" checked="checked" @click="setTabIndex(0)">
        <button class="tabbar__button"
          v-bind:class="{ 'ph-btn': initLoading }"
        >
          {{ $t("subscriptions.latest") }}
        </button>
        </label>
        <label class="tabbar__item" data-index="2">
        <input type="radio" name="tab-tag" @click="setTabIndex(1)">
        <button class="tabbar__button">
          {{ $t("subscriptions.channels") }}
        </button>
        </label>
      </div>
      <div class="tabs-content" id="tabs-content-tag">
        <div v-show="tabIndex === 0">
          <section
            v-for="published_date in Object.keys(episodesGroupByDate).sort((a, b) => b-a)"
            :key="published_date"
          >
            <h2 class="timeline-date"><time :datetime="timestampToDate(published_date)">{{ published_date | timestampHumanizeDate }}</time></h2>
            <div class="container">
              <episode-list-detailed :mediaLeft="true" :episodes="episodesGroupByDate[published_date]" :subscribeButtonEnabled="true" :on-toggle-subscribe-start="onToggleSubscribeStart" :on-toggle-subscribe-error="onToggleSubscribeError" :on-toggle-subscribe-end="onToggleSubscribeEnd" :channel-loading="channelLoading" :set-channel-loading="setChannelLoading" :unread-new-episodes-checked-at="unreadNewEpisodesCheckedAt" :loading="initLoading" :loading-item-count="2" />
            </div>
          </section>
          <div class="center-align">
            <p>
              <v-ons-button class="btn-outline" modifier="long"
                v-show="!episodesEnded"
                :disabled="loading"
                @click="loadMore()"
              >{{ $t("ui.load_more") }}</v-ons-button>
            </p>
            <p v-show="episodesEnded">{{ $t("ui.no_more") }}</p>
          </div>
        </div>
        <div v-show="tabIndex === 1">
          <div class="pd-bottom container">
            <channel-list-detailed :channels="channels" :on-toggle-subscribe-start="onToggleSubscribeStart" :on-toggle-subscribe-error="onToggleSubscribeError" :on-toggle-subscribe-end="onToggleSubscribeEnd" :loading="initLoading" :loading-item-count="5" />
          </div>          
        </div>
      </div>      
    </main>
    <float-player />
  </v-ons-page>
</template>

<script>
import TopPullHook from '@/components/TopPullHook.vue';
import EpisodeListDetailed from '@/components/EpisodeListDetailed.vue';
import ChannelListDetailed from '@/components/ChannelListDetailed.vue';
import FloatPlayer from '@/components/FloatPlayer.vue';
import Episode from '@/models/Episode';
import WatchUserChangeHelper from '@/mixins/WatchUserChangeHelper';
import TabHelper from '@/mixins/TabHelper';
import Channel from '@/models/Channel';

export default {
  name: 'subscriptions',
  components: {
    'top-pull-hook': TopPullHook,
    'episode-list-detailed': EpisodeListDetailed,
    'channel-list-detailed': ChannelListDetailed,
    'float-player': FloatPlayer,
  },
  mixins: [TabHelper, WatchUserChangeHelper],

  data() {
    return {
      initLoading: true,
      loading: true,
      showing: false,
      channelLoading: {},
      episodesEnded: false,
      newUnreadNewEpisodesCheckedAt: Math.floor(Date.now() / 1000),
    };
  },

  computed: {
    episodes() {
      return Episode.query().where('_is_from_subscription', true).with('channel').orderBy('published_at', 'desc').get();
    },
    newEpisodesCount() {
      return this.episodes.filter((episode) => this.unreadNewEpisodesCheckedAt <= episode.published_at).length;
    },
    episodesGroupByDate() {
      let offset = (new Date()).getTimezoneOffset() * 60;
      return this.episodes.reduce(function (r, episode) {
        let published_date = Math.floor((episode.published_at - offset)/86400) * 86400 + offset;
        r[published_date] = r[published_date] || [];
        r[published_date].push(episode);
        return r;
      }, {});
    },
    unreadNewEpisodesCheckedAt() {
      return this.currentUser.unread_new_episodes_checked_at || this.newUnreadNewEpisodesCheckedAt;
    },
    channels() {
      return Channel.query().where('is_subscribed', true).with('episodes').get();
    },
  },

  methods: {
    onToggleSubscribeStart() {
      this.loading = true;
    },
    onToggleSubscribeError(error) {
      console.log(error);
      this.showSomethingWrongToast();
    },
    onToggleSubscribeEnd() {
      this.loading = false;
      this.$forceUpdate();
    },
    setChannelLoading(channelId, value) {
      this.channelLoading[channelId] = value;
    },
    updateSubscriptionsBadge() {
      if (this.newEpisodesCount === 0) {
        this.$store.commit('navigator/setSubscriptionsTabBadge', null);
      } else if (this.newEpisodesCount === this.episodes.length) {
        this.$store.commit('navigator/setSubscriptionsTabBadge', `${this.newEpisodesCount}+`);
      } else {
        this.$store.commit('navigator/setSubscriptionsTabBadge', `${this.newEpisodesCount}`);
      }
    },
    reload(done) {
      this.initLoading = true;
      Episode.unsetAllIsFromSubscription();
      this.loadMore(() => {
        this.newUnreadNewEpisodesCheckedAt = Math.floor(Date.now() / 1000);
        this.initLoading = false;
        if (done) { done(); }
        if (this.showing && this.episodes.length > 0) { this.askPushNotification(); }
      });
    },
    loadMore(onEnd) {
      let that = this;
      this.loading = true;
      Episode.fetchAllOrMoreSubscribedEpisodes(this.currentUser.id).then((result) => {
        if (!result.entities || !result.entities.episodes || result.entities.episodes.length <= 0) {
          this.episodesEnded = true;
        }
        this.updateSubscriptionsBadge();
      }).catch((err) => {
        console.log(err);
        that.showSomethingWrongToast();
      }).finally(() => {
        this.loading = false;
        if (onEnd) { setTimeout(() => { onEnd(); }, 0); }
      });

      Channel.fetchAllSubscribedChannelsIncludeEpisodes(this.currentUser.id)
        .catch(function (error) {
          console.log(error);
          that.showSomethingWrongToast();
        }).finally(() => {
          this.loading = false;
        });
    },
    onShow() {
      this.showing = true;
      if (!this.initLoading && this.episodes.length > 0) { this.askPushNotification(); }
      if (this.currentUser._subscriptions_changed) {
        this.currentUser.updateSubscriptionsChanged(false);
        this.reload();
      }
    },
    onHide() {
      this.showing = false;
      if (this.newUnreadNewEpisodesCheckedAt > this.currentUser.unread_new_episodes_checked_at) {
        this.currentUser.update({ unread_new_episodes_checked_at: this.newUnreadNewEpisodesCheckedAt }).then(() => {
          this.updateSubscriptionsBadge();
        });
      }
    },
    onUserChanged() {
      this.reload();
    },
  },

  created() {
    this.reload();
  },
};
</script>
